import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

import page_img from '../../components/Navigation/icons/notifiche.svg'
import add_img from '../../assets/images/add.svg'


import { setLoading } from '../../services/global/globalSlice';
import ConfirmModal from '../../components/_modals/ConfirmModal';
import { Form, InputGroup, Tab, Tabs } from 'react-bootstrap';
import Button from '../../components/Button';
import CommunicationsTable from './_components/CommunicationsTable';

export default function CommunicationsHome(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [statusFilter, setStatusFilter] = useState("all")
    const [filter, setFilter] = useState({
        started: null,
        ended: null,
        type: "",
        limit: 25,
    })
    const [isUpdated, setIsUpdated] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const changeStatusFilter = (e) => {
        switch(e.target.value){
            case 'all' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    type: "",
                    limit: 20,
                })
            } break;
            case 'progress' : {
                setFilter({
                    ...filter,
                    started: true,
                    ended: false,
                    type: "",
                    limit: 20,
                })
            } break;
            case 'future' : {
                setFilter({
                    ...filter,
                    started: false,
                    ended: null,
                    type: "",
                    limit: 20,
                })
            } break;
            case 'past' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: true,
                    type: "",
                    limit: 20,
                })
            } break;
            case 'banner' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    type: "banner",
                    limit: 20,
                })
            } break;
            case 'popup' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    type: "popup",
                    limit: 20,
                })
            } break;
            default: {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    state: "",
                    limit: 20,
                })
            }
        }
        setStatusFilter(e.target.value)
    }

    return (
        <section id="examsScreen">
            {
                <>
                    
                    <div className='d-flex align-items-center justify-content-between'>
                        <div className="page_title">
                            <img src={page_img} />
                            <h1>{t.communications.page_title}</h1>
                        </div>
                        <div className='d-flex'>
                            <Link to={'/communications/create'}>
                                <button className='ms-2'>
                                    {t.communications.new_comm}
                                    <img src={add_img} className='ms-2' />
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className='d-flex mt-2 mb-3 exams-step-0'>
                    <div className='custom-radio-tab'>
                        <input type="radio" id="1" name="statusFilter" value="all" checked={statusFilter === "all"} onChange={changeStatusFilter}/>
                        <label htmlFor="1">
                            {t.exams.all}
                        </label>
                    </div>
                    <div className='custom-radio-tab ms-4'>
                        <input type="radio" id="2" name="statusFilter" value="progress" checked={statusFilter === "progress"} onChange={changeStatusFilter} />
                        <label htmlFor="2">
                            {t.exams.progress}
                        </label>
                    </div>
                    <div className='custom-radio-tab ms-4'>
                        <input type="radio" id="3" name="statusFilter" value="future" checked={statusFilter === "future"} onChange={changeStatusFilter}/>
                        <label htmlFor="3">
                            {t.exams.future}
                        </label>
                    </div>
                    <div className='custom-radio-tab ms-4'>
                        <input type="radio" id="4" name="statusFilter" value="past" checked={statusFilter === "past"} onChange={changeStatusFilter}/>
                        <label htmlFor="4">
                            {t.exams.past}
                        </label>
                    </div>
                    <div className='custom-radio-tab ms-4'>
                        <input type="radio" id="5" name="statusFilter" value="banner" checked={statusFilter === "banner"} onChange={changeStatusFilter}/>
                        <label htmlFor="5">
                            {'Banner'}
                        </label>
                    </div>
                    <div className='custom-radio-tab ms-4'>
                        <input type="radio" id="6" name="statusFilter" value="popup" checked={statusFilter === "popup"} onChange={changeStatusFilter}/>
                        <label htmlFor="6">
                            {'Popup'}
                        </label>
                    </div>
                </div>
                    <CommunicationsTable 
                        filter={filter}
                    />
                    <ConfirmModal props={confirmModal}/>
                    
                </>
            }
            
        </section>
    )
}